export default "__VITE_ASSET__CbD6cCgk__"